import { EndpointBuilder } from "@reduxjs/toolkit/dist/query/endpointDefinitions";
import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from "@reduxjs/toolkit/dist/query";

import { GetScheduleRequest, UpdateScheduleRequest } from "api/types/requests";
import { ScheduleResponse } from "api/types/responses";
import QueryTags from "api/types/QueryTags";
import ScheduleWeekDay from "api/types/models/schedule_weekday";

const scheduleEndpoints = (
  builder: EndpointBuilder<
    BaseQueryFn<
      string | FetchArgs,
      unknown,
      FetchBaseQueryError,
      {},
      FetchBaseQueryMeta
    >,
    QueryTags,
    "data"
  >,
) => ({
  getSiteSchedule: builder.query<ScheduleResponse, GetScheduleRequest>({
    query: ({ locationUuid }) => ({
      url: "/locations/schedule",
      params: {
        ...(locationUuid && { location_uuid: locationUuid }),
      },
    }),
    providesTags: ["SiteSchedule"],
  }),

  updateSiteSchedule: builder.mutation<
    ScheduleWeekDay[],
    UpdateScheduleRequest
  >({
    query: (body) => ({
      url: "/locations/schedule",
      method: "put",
      body,
    }),
    invalidatesTags: ["SiteSchedule"],
  }),
});

export default scheduleEndpoints;
